import React from 'react';

import { ButtonLinkType } from '../../graphql-fragments/ButtonLink';
import { getUrlFromVersatileLink } from '../../utils/sanity';
import { clsx } from '../../utils/utils';
import Button from './Button';
import * as styles from './ButtonLink.module.scss';
import SmartLink from './SmartLink';

interface ButtonLinkBaseProps extends Omit<React.HTMLAttributes<HTMLAnchorElement>, 'onClick'> {
  outlined?: boolean;
  secondary?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  buttonClassName?: string;
}

export type ButtonLinkProps = ButtonLinkBaseProps &
  (
    | {
        button: ButtonLinkType;
        href?: never;
        children?: never;
      }
    | {
        button?: never;
        href: string;
        children: React.ReactNode;
      }
  );

export default React.forwardRef<any, ButtonLinkProps>(function ButtonLink(
  { button, href, onClick, outlined, secondary, className, buttonClassName, children, ...restProps },
  ref,
): React.ReactElement {
  return (
    <SmartLink
      ref={ref}
      className={clsx(className, styles.link)}
      to={button ? getUrlFromVersatileLink(button) : href}
      tabIndex={-1}
      {...restProps}
    >
      <Button
        onClick={onClick}
        outlined={outlined}
        className={buttonClassName}
        secondary={secondary}
      >
        {button?.text || children}
      </Button>
    </SmartLink>
  );
});
